'use strict';

import { environment } from '@quartz-gov-legacy/environments/environment';

angular.module('observationModule')

.factory('grcObservationService', ['$http', '$q', function ($http, $q) {
    var baseUrl = environment.apiUrl + '/Pilot/api/Recom';

    var service = {};

    // Retrieve Observations
    service.getObservation = function (observationId) {
        return $http
            .get(baseUrl + '/Observation/' + observationId)
            .then(function (response) { return response.data; });
    };

    service.getObservationsByGovernanceProcess = function (governanceProcessId) {
        return $http
            .get(baseUrl + '/For/AuditMandate/' + governanceProcessId + '/Observation')
            .then(function (response) { return response.data; });
    };

    service.getObservationsByControlID = function (controlId) {
        return $http
            .get(baseUrl + '/Control/' + controlId + '/Observation')
            .then(function (response) { return response.data; });
    };

    service.getObservationsByControlTestID = function (controlId, controlTestId) {
        return $http
            .get(baseUrl + '/Control/Test/' + controlTestId + '/Observation')
            .then(function (response) { return response.data; });
    };

    // Create or update
    service.updateObservation = function (observation) {
        return $http
            .put(baseUrl + '/Observation/' + observation.ObservationID, observation)
            .then(function (response) { return response.data; });
    };

    // Delete
    service.deleteObservation = function (observation) {
        return $http
            .delete(baseUrl + '/Observation/' + observation.ObservationID)
            .then(function (response) { return response.data; });
    };


    service.createObservationFromTestResult = function (testResultId, observation) {
        var reqUrl = baseUrl + '/For/TestResult/' + testResultId + '/Observation';

        return $http
            .post(reqUrl, observation)
            .then(function (response) { return response.data; });
    };

    service.createFromGovernanceProcess = function (observation) {
        delete observation.GovernanceProcess;
        var reqUrl = baseUrl + '/For/AuditMandate/' + observation.GovernanceProcessID + '/Observation';
        return $http
            .post(reqUrl, observation)
            .then(function (response) { return response.data; });
    };

    service.createFromCampaign = function (observation) {
        var reqUrl = baseUrl + '/For/Campaign/' + observation.ODDCampaignID + '/Observation';
        return $http
            .post(reqUrl, observation)
            .then(function (response) { return response.data; });
    };

    // Recommendation
    service.getRecommendationsByObservationID = function (observationId) {
        return $http
            .get(baseUrl + '/Observation/' + observationId + '/Recommendation')
            .then(function (response) { return response.data; });
    };

    // Related Controls
    service.getRelatedControls = function (observationId) {
        return $http
            .get(baseUrl + '/Observation/' + observationId + '/Control')
            .then(function (response) { return response.data; });
    };

    service.addControlToObservation = function (observationId, controlId) {
        return $http
            .post(baseUrl + '/Observation/' + observationId + '/Control/' + controlId)
            .then(function (response) { return response.data; });
    };
    service.removeControlFromObservation = function (observationId, controlId) {
        return $http
            .delete(baseUrl + '/Observation/' + observationId + '/Control/' + controlId)
            .then(function (response) { return response.data; });
    };


    return service;
}]);
